import React, { createContext, useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

import './Tabs.css'

const TabContext = createContext({
	activeTab: '',
	setActiveTab: () => {},
  });


export function Tabs({ initialId , children }) {

	const [activeTab, setActiveTab] = useState( initialId ?? '')

	useEffect(() => {
 
		//console.log('activeTab : ' , activeTab);
		//console.log('initialId : ' , initialId);
		if(initialId) setActiveTab(initialId)	
		//console.log('activeTab : ' , activeTab);
	}, [])
	
	const handleHeaderClick = (event) => {
		// do something
		event.stopPropagation();
	};
	

	return (
		<TabContext.Provider value={{ activeTab , setActiveTab }}>
			<div 
				className={`tabs`}
				onClick={handleHeaderClick}
				>{ children }</div>	
		</TabContext.Provider>
	)

}
/**
 * 
 * @param {*} param0 
 * @returns 
 */
function Item({ id , href , children }) {

	const { activeTab, setActiveTab } = useContext(TabContext);


	return (
		<div className={`tab-item ${activeTab === id ? 'active' : ''}`}>
			{
				href 
				? <Link  
					to={href} 
					onClick={ () => setActiveTab(id)}
					className="tab-item-link"
					>{ children }</Link>
				: <div 
					onClick={ () => setActiveTab(id)}
					className="tab-item-link">{ children }</div> 
			}				
		</div>
	)
}

Tabs.Item = Item
